import { Component } from "react";
import PropTypes from "prop-types";
import colorHelper from "../../utils/color-helper";
import { ChevronDownOutline, CheckmarkOutline } from "@carbon/icons-react";

class ColorSass extends Component {
  /**
   * Copy the provided element's text content to the clipboard and show a
   * temporary visual confirmation on the trigger element.
   * @param {Event} evt Trigger event
   * @param {HTMLElement} element DOM element containing text to copy
   */
  copyToClipboard = (evt, element) => {
    navigator.clipboard.writeText(element.textContent).then(
      () => {
        evt.target.classList.add("copied");
        setTimeout(() => {
          evt.target.classList.remove("copied");
        }, 2000);
      },
      (err) => {
        alert("Failed to copy: ", err);
      },
    );
  };

  render() {
    const { steps } = this.props;

    let sassCode = "";
    let cssVariableCode = "";

    steps.forEach((step, index) => {
      sassCode += `/// ${step.name} color tokens \n\r`;
      cssVariableCode += `/* ${step.name} CSS Variables */ \n\r`;
      step.colors.forEach((color, index) => {
        sassCode +=
          `$${step.name.toLowerCase().split(` `).join(`-`)}-${10 * (index + 1)}: ${colorHelper.formatter("hex")(color)};` +
          "\n\r";
        cssVariableCode +=
          `--${step.name.toLowerCase().split(` `).join(`-`)}-${10 * (index + 1)}: ${colorHelper.formatter("hex")(color)};` +
          "\n\r";
      });
      sassCode += "\n\r";
      cssVariableCode += "\n\r";
      // console.log("there are cssVariableCode", cssVariableCode);
    });

    return (
      <div>
        <div className="color-tokens">
          <details>
            <summary>
              <ChevronDownOutline size={16} /> View Sass Tokens
            </summary>
            <div>
              <div className="color-tokens--actions">
                <button
                  onClick={(evt) =>
                    this.copyToClipboard(
                      evt,
                      document.getElementById("sass-code"),
                    )
                  }
                >
                  Copy Sass Tokens
                </button>{" "}
                <span className="copy-success">
                  <CheckmarkOutline size={24} /> Copied
                </span>
              </div>
              <xmp id="sass-code">{sassCode}</xmp>
            </div>
          </details>
          <details>
            <summary>
              <ChevronDownOutline size={16} /> View CSS Variable Tokens
            </summary>
            <div>
              <div className="color-tokens--actions">
                <button
                  onClick={(evt) =>
                    this.copyToClipboard(
                      evt,
                      document.getElementById("css-variable-code"),
                    )
                  }
                >
                  Copy CSS Variable Tokens
                </button>
                <span className="copy-success">
                  <CheckmarkOutline size={24} /> Copied
                </span>
              </div>
              <xmp id="css-variable-code">{cssVariableCode}</xmp>
            </div>
          </details>
        </div>
      </div>
    );
  }
}

ColorSass.propTypes = {
  steps: PropTypes.array,
  readOnly: PropTypes.bool,
  owner: PropTypes.bool,
  paletteDetails: PropTypes.shape({
    paletteName: PropTypes.string,
  }),
};

ColorSass.defaultProps = {
  steps: [],
  owner: false,
  readOnly: true,
  details: {},
};

export default ColorSass;
